import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { pageActions } from "../../store/page";

import { Snackbar, Slide, Alert } from "@mui/material";

import useLocalization from "../../hooks/useLocalization";

function TransitionDown(props) {
  return (
    <Slide
      {...props}
      direction="down"
    />
  );
}

const Toast = () => {
  const dispatch = useDispatch();
  const { getMessage } = useLocalization();

  const isShown = useSelector((state) => state.page.show);
  const message = useSelector((state) => state.page.message);
  const status = useSelector((state) => state.page.status);

  const handleClose = () => {
    dispatch(pageActions.resetMessage());
  };

  return (
    <Snackbar
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={isShown}
      autoHideDuration={3000}
      onClose={handleClose}
      slots={{ transition: TransitionDown }}
    >
      <Alert severity={status}>{getMessage(message)}</Alert>
    </Snackbar>
  );
};

export default Toast;
